// ###### IMPORTS
import api from 'connections/api';
import routes_api from 'connections/routes_api';

// ###### API FUNCTIONS
export const fetchMetadataCategoriesHierarchical = async () => {
  try {
    const response = await api.get(routes_api.finance_flows_categories_hierarchical);
    return response.data || {};
  } catch (error) {
    console.error('Error fetching hierarchical categories:', error);
    throw error;
  }
};

export const fetchMetadataCategories = async () => {
  try {
    const response = await api.get(routes_api.finance_flows_categories);
    return response.data.results || [];
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

export const createMetadataCategory = async (categoryData) => {
  try {
    const response = await api.post(routes_api.finance_flows_categories, categoryData);
    return response.data;
  } catch (error) {
    console.error('Error creating category:', error);
    throw error;
  }
};

export const updateMetadataCategory = async (categoryId, categoryData) => {
  try {
    const response = await api.put(`${routes_api.finance_flows_categories}${categoryId}/`, categoryData);
    return response.data;
  } catch (error) {
    console.error('Error updating category:', error);
    throw error;
  }
};

export const partialUpdateMetadataCategory = async (categoryId, categoryData) => {
  try {
    const response = await api.patch(`${routes_api.finance_flows_categories}${categoryId}/`, categoryData);
    return response.data;
  } catch (error) {
    console.error('Error partially updating category:', error);
    throw error;
  }
};

export const deleteMetadataCategory = async (categoryId) => {
  try {
    const response = await api.delete(`${routes_api.finance_flows_categories}${categoryId}/`);
    return response.data;
  } catch (error) {
    console.error('Error deleting category:', error);
    throw error;
  }
};

// ###### NEW HIERARCHICAL UPDATE/DELETE FUNCTIONS
export const updateHierarchicalCategory = async (level, categoryId, actionType, newData = {}) => {
  try {
    const response = await api.put(`${routes_api.finance_flows_categories}update-hierarchical/`, {
      level,
      category_id: categoryId,
      action_type: actionType,
      new_data: newData
    });
    return response.data;
  } catch (error) {
    console.error('Error updating hierarchical category:', error);
    throw error;
  }
};

export const deleteHierarchicalCategory = async (level, categoryId) => {
  try {
    const response = await api.delete(`${routes_api.finance_flows_categories}update-hierarchical/`, {
      data: {
        level,
        category_id: categoryId,
        action_type: 'delete'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting hierarchical category:', error);
    throw error;
  }
};

export const batchUpdateMetadataCategories = async (categories) => {
  try {
    const response = await api.put(`${routes_api.finance_flows_categories}batch-update/`, {
      categories
    });
    return response.data;
  } catch (error) {
    console.error('Error batch updating categories:', error);
    throw error;
  }
};

export const getMetadataCategoryById = async (id) => {
  try {
    const response = await api.get(`${routes_api.finance_flows_categories}${id}/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching category by ID:', error);
    throw error;
  }
};

export const searchMetadataCategories = async (query) => {
  try {
    const response = await api.get(routes_api.finance_flows_categories, {
      params: { search: query }
    });
    return response.data.results || [];
  } catch (error) {
    console.error('Error searching categories:', error);
    throw error;
  }
};
